import { Link, useLocation } from "@tanstack/react-router";
import { useAtom } from "jotai";
import type React from "react";
import { useTranslation } from "react-i18next";
import { NavItem } from "@/components/ui/nav-item";
import { ChatList } from "@/features/chat/components/ChatList";
import { StudyGroupList } from "@/features/my-study-groups/components/StudyGroupList";
import { clearStudyGroupAtom } from "@/stores/studyGroupAtoms";

// ナビゲーションアイテムの定義
const NAV_ITEMS = [
  {
    to: "/favorites",
    iconSrc: "/favorite.svg",
    labelKey: "common.favorites",
    pathMatch: "favorites",
  },
  {
    to: "/event-search",
    iconSrc: "/search.svg",
    labelKey: "common.eventSearch",
    pathMatch: "event-search",
  },
  {
    to: "/all-study-groups",
    iconSrc: "/add.svg",
    labelKey: "common.allStudyGroups",
    pathMatch: "all-study-groups",
  },
] as const;

export const Sidebar: React.FC = () => {
  const { pathname } = useLocation();
  const [, clearStudyGroup] = useAtom(clearStudyGroupAtom);
  const { t } = useTranslation();

  // Function to clear study group selection when clicking on other menu items
  const handleMenuItemClick = () => {
    clearStudyGroup();
  };

  return (
    <aside className="relative flex min-h-full w-[307px] flex-col border-study-group-selected border-r-2 bg-variable-collection-light-gray py-[26px]">
      {/* ロゴ・タイトル部分 */}
      <Link to="/" className="mb-[22px] block transition-opacity hover:opacity-80">
        <h1 className="pl-4 font-[number:var(--logo-font-weight)] text-variable-collection-black-gray text-xl">
          Study Group Lounge
        </h1>
      </Link>

      {/* ナビゲーション部分 */}
      <nav className="mb-[22px] w-full min-w-0 space-y-[22px] overflow-x-hidden pr-[50px]">
        {NAV_ITEMS.map((item) => {
          const isActive = pathname.includes(item.pathMatch);
          return (
            <NavItem
              key={item.to}
              to={item.to}
              icon={<img src={item.iconSrc} alt="" className="h-[18px] w-[18px]" />}
              label={t(item.labelKey)}
              isActive={isActive}
              onClick={handleMenuItemClick}
            />
          );
        })}
      </nav>

      {/* スタディグループリスト */}
      <div className="mb-[22px] w-full min-w-0 overflow-x-hidden pr-[30px] pl-[20px]">
        <StudyGroupList containerHeight="27vh" />
      </div>

      {/* チャットリスト */}
      <div className="w-full min-w-0 overflow-x-hidden pr-[30px] pl-[20px]">
        <ChatList onClick={handleMenuItemClick} containerHeight="27vh" />
      </div>
    </aside>
  );
};
